import { render, staticRenderFns } from "./ProfileNotificationsSettings.vue?vue&type=template&id=554f912c&"
import script from "./ProfileNotificationsSettings.vue?vue&type=script&lang=js&"
export * from "./ProfileNotificationsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports